const en = {
  // ── Nav ──────────────────────────────────────────────
  nav: {
    home:     'Home',
    services: 'Services',
    projects: 'Projects',
    about:    'About',
    contact:  'Contact',
    cta:      'Start a project',
  },

  // ── Hero ─────────────────────────────────────────────
  hero: {
    words: [
      { t: 'Web,',       a: false },
      { t: 'software',   a: false },
      { t: '&',          a: false },
      { t: 'AI',         a: true  },
      { t: 'built',      a: false },
      { t: 'for',        a: false },
      { t: 'you.',       a: false },
    ],
    ariaLabel: 'Web, software & AI built for you.',
    sub: 'Websites, business apps and AI solutions — designed and delivered directly, no middlemen.',
    ctaPrimary: 'Discuss my project',
    ctaGhost:   'View my services',
    stats: [
      ['10+', 'projects delivered'],
      ['24h', 'response time'],
      ['100%', 'custom-built'],
    ],
    scroll: 'SCROLL',
  },

  // ── HomeAbout ─────────────────────────────────────────
  homeAbout: {
    eyebrow: 'About',
    title1:  'One developer,',
    title2:  'full commitment.',
    body:    'I\'m Islam B., an independent developer based in Sherbrooke. I design and deliver websites, business apps and AI solutions — solo, no middlemen, from the first call to go-live.',
    stack:   ['Websites', 'Custom Software', 'AI Solutions', 'Maintenance', 'UI/UX Design'],
    link:    'Learn more',
    stat1:   ['10+', 'projects delivered'],
    stat2:   ['100%', 'custom-built'],
    stat3:   ['24 h', 'response time'],
    note:    '"I get involved where it matters: understanding your business before proposing a solution."',
  },

  // ── HomeServices ──────────────────────────────────────
  homeServices: {
    eyebrow: 'What I do',
    title:   'Tailored solutions\nfor every need',
    cards: [
      { title: 'Business websites',            desc: 'Showcase sites, landing pages, corporate sites, redesign and optimization.' },
      { title: 'Custom software development',  desc: 'Web apps, dashboards, client portals, APIs, SaaS platforms.' },
      { title: 'AI solutions',                  desc: 'AI agents, predictive models, multi-agent systems, computer vision.' },
      { title: 'Maintenance & evolution',       desc: 'Feature additions, bug fixes, migrations, performance improvements.' },
    ],
  },

  // ── CTASection ────────────────────────────────────────
  cta: {
    tag:      '// READY TO START?',
    title1:   'You have a complex problem',
    title2:   'that needs solving.',
    sub:      'Describe it. We\'ll get back to you with a clear approach, no jargon, no commitment.',
    primary:  'Start a project',
    ghost:    'Explore our services',
    chips:    ['✓ Reply within 24h', '✓ No commitment', '✓ Direct expertise'],
  },

  // ── Footer ────────────────────────────────────────────
  footer: {
    tagline:   'Independent studio · web, software\n& AI development — Canada.',
    nav: ['Home', 'Services', 'Projects', 'About', 'Contact'],
    copy:      '© 2025 AxisDev — Islam B.',
    status:    'Available for new projects',
  },

  // ── About (home section) ──────────────────────────────
  about: {
    eyebrow: 'About',
    title:   'AxisDev is an independent studio specializing in software development and artificial intelligence.',
    body1:   'I help businesses build professional websites, business applications, AI agents and custom software solutions. My approach combines technical expertise, a deep understanding of your real needs, and the development of concrete, reliable and scalable solutions.',
    body2:   'Every project is handled directly — from initial analysis through to deployment — with clear communication and personalized support.',
    cta1:    'Work together',
    cta2:    'My process',
    tags:    ['Websites & apps', 'AI / LLM solutions', 'UI/UX Design', 'Cloud & DevOps', 'Custom-built'],
    skills:  'Key skills',
  },

  // ── AboutPage ─────────────────────────────────────────
  aboutPage: {
    eyebrow:     'About',
    heroTitle:   'Software developer & AI',
    heroAccent:  'specialist.',
    name:        'Islam B.',
    role:        'Founder · AxisDev',
    location:    'Based in Canada · Available for international projects',
    skills:      ['Websites', 'Business apps', 'AI solutions', 'LLM agents', 'UI/UX Design', 'Cloud & DevOps', 'APIs', 'Automation'],
    cta1:        'Work together',
    cta2:        'My process',
  },

  // ── Contact ───────────────────────────────────────────
  contact: {
    eyebrow:      'Contact',
    title:        'Got a project in mind?',
    sub:          'Describe it briefly — I\'ll get back to you within 24h.',
    nameLabel:    'Full name',
    emailLabel:   'Email',
    typeLabel:    'Project type',
    descLabel:    'Project description',
    projectTypes: ['Website', 'Software application', 'AI solution', 'Maintenance', 'Other'],
    typeDefault:  'Select...',
    namePh:       'example',
    emailPh:      'you@example.com',
    descPh:       'Describe your project — goals, constraints, desired timeline...',
    submitBtn:    'Send my request',
    successTitle: 'Request sent',
    successSub:   'I\'ll get back to you within 24h.',
    emailLabel2:  'Direct email',
    callHint:     'Prefer a call? Mention it in your message.',
  },

  // ── Projects ──────────────────────────────────────────
  projects: {
    eyebrow:    'Projects',
    title:      'What we\'ve delivered.',
    sub:        'Real projects, in production. Each one solves a concrete business problem.',
    visitSite:  'Visit website',
    teaserTag:  'Next project',
    teaserText: 'Yours could be next.\nLet\'s talk.',
    teaserCta:  'Start yours',
  },

  // ── Services Page ─────────────────────────────────────
  servicesPage: {
    eyebrow:    'Services',
    title1:     'What I',
    title2:     'build.',
    sub:        'Three areas of expertise, one address — directly at your service, no middlemen.',
    serviceCta: 'See this service',
    services: [
      { title: 'Business websites',               desc: 'Showcase sites, landing pages, corporate sites and redesigns — modern, credible and conversion-focused.',                                               pills: ['Showcase site', 'Landing page', 'Redesign', 'Basic SEO', 'Responsive'] },
      { title: 'Custom AI solutions',              desc: 'Predictive models, AI agents, fine-tuning, computer vision and integration into your existing software.',                                              pills: ['AI agents', 'RAG', 'LLM fine-tuning', 'Vision', 'Multi-agents'] },
      { title: 'Software development',             desc: 'Full-stack web applications, SaaS, APIs and business tools built to hold up in production.',                                                          pills: ['Full-stack', 'SaaS', 'REST API', 'Mobile', 'Architecture'] },
      { title: 'Maintenance & software evolution', desc: 'Taking over existing projects, bug fixes, feature additions and migrations — without starting from scratch.',                                        pills: ['Project takeover', 'Migration', 'UI redesign', 'Performance', 'API'] },
    ],
  },
};

export default en;
